import { createContext, useContext } from "react";
import { makeAutoObservable } from "mobx";
import { WelcomePageStore } from "./WelcomePageStore.ts";
import { GlobalStore } from "./GlobalStore.ts";
import { injectStores } from "@mobx-devtools/tools";
import { WalletStore } from "./WalletStore.ts";
import { ServiceStore } from "./ServiceStore.ts";

class RootStore {
    WelcomeStore: WelcomePageStore;
    GlobalStore: GlobalStore;
    WalletStore: WalletStore;
    ServiceStore: ServiceStore;

    constructor() {
        this.WelcomeStore = new WelcomePageStore(this);
        this.GlobalStore = new GlobalStore(this);
        this.WalletStore = new WalletStore(this);
        this.ServiceStore = new ServiceStore(this);
        makeAutoObservable(this);
    }
}

const rootStore = new RootStore();

// IMPORTANT без этой проверки падает background.ts, т.е. не запускается service worker
if (process.env.APP_TYPE !== "ext") {
    injectStores({
        rootStore,
    });
}

const StoreContext = createContext(rootStore);

function useRootStore() {
    const context = useContext(StoreContext);
    if (context === undefined) {
        throw new Error("useRootStore must be used within RootStoreProvider");
    }

    return context;
}

export { rootStore, useRootStore, RootStore };
